/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_Score_TitleInputs */

const en_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your ATS Score`)
};

const de_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein ATS-Score`)
};

const fr_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton score ATS`)
};

const es_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu puntuación ATS`)
};

const it_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo punteggio ATS`)
};

const nl_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw ATS-score`)
};

const pl_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój wynik ATS`)
};

const fi_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-pisteesi`)
};

const da_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din ATS-score`)
};

const sv_onboarding_ats_score_title = /** @type {(inputs: Onboarding_Ats_Score_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt ATS-resultat`)
};

/**
* | output |
* | --- |
* | "Your ATS Score" |
*
* @param {Onboarding_Ats_Score_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_score_title = /** @type {((inputs?: Onboarding_Ats_Score_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_Score_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_score_title(inputs)
	if (locale === "fr") return fr_onboarding_ats_score_title(inputs)
	if (locale === "es") return es_onboarding_ats_score_title(inputs)
	if (locale === "it") return it_onboarding_ats_score_title(inputs)
	if (locale === "nl") return nl_onboarding_ats_score_title(inputs)
	if (locale === "pl") return pl_onboarding_ats_score_title(inputs)
	if (locale === "fi") return fi_onboarding_ats_score_title(inputs)
	if (locale === "da") return da_onboarding_ats_score_title(inputs)
	if (locale === "sv") return sv_onboarding_ats_score_title(inputs)
	return en_onboarding_ats_score_title(inputs)
});